import { createApi } from '@reduxjs/toolkit/query/react';
import { call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { toast } from 'react-toastify';
import { exportXlsxFromBlob, baseApi } from '@centerpiece/components';

type ProjectsQueryParams = {
  status?: string;
  type?: number;
  team?: number;
  estimator?: number;
  archived?: string;
  consultant?: number;
  customer?: number;
  competitor?: number;
};

export const dataexport = baseApi
  // .enhanceEndpoints({ addTagTypes: ['Appointments', 'Appointment'] })
  .injectEndpoints({
    endpoints: builder => ({
      getVolumeAnalyticsExport: builder.query<any, { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: '/analytics/volume/export',
          params: params,
          responseHandler: response => response.text(), // not json
        }),
      }),
      getPricingAnalyticsExport: builder.query<any, { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: '/analytics/pricing/export',
          params: params,
          responseHandler: response => response.text(),
        }),
      }),
      getForecastAnalyticsExport: builder.query<any, { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: '/analytics/forecast/export',
          params: params,
          responseHandler: response => response.text(),
        }),
      }),
      getPerformanceAnalyticsExport: builder.query<any, void>({
        query: () => ({
          url: '/analytics/performance/export',
          responseHandler: response => response.text(),
        }),
      }),
      getProjectsExport: builder.query<any, { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: '/projects/export',
          params: params,
          responseHandler: response => response.text(),
        }),
      }),
    }),
  });

// Auto-generated hooks
export const {
  useLazyGetPricingAnalyticsExportQuery,
  useLazyGetVolumeAnalyticsExportQuery,
  useLazyGetForecastAnalyticsExportQuery,
  useLazyGetProjectsExportQuery,
  useLazyGetPerformanceAnalyticsExportQuery,
} = dataexport;

export function* dataExportSaga() {
  yield all([
    takeLatest(
      dataexport.endpoints.getVolumeAnalyticsExport.matchFulfilled,
      watchExportBidVolumeAndWinRateChartData
    ),
    takeLatest(
      dataexport.endpoints.getPricingAnalyticsExport.matchFulfilled,
      watchExportPricingChartData
    ),
    takeLatest(
      dataexport.endpoints.getForecastAnalyticsExport.matchFulfilled,
      watchExportRevenueForecastChartData
    ),
    takeLatest(
      dataexport.endpoints.getPerformanceAnalyticsExport.matchFulfilled,
      watchExportFactorAnalysisTableData
    ),
    takeLatest(
      dataexport.endpoints.getProjectsExport.matchFulfilled,
      watchExportAllProjectsTableData
    ),
  ]);
}

export function* watchExportAllProjectsTableData(action: any) {
  try {
    const { payload } = action;
    const filename = `projects_${moment(new Date()).format('MM-DD-YY')}.xlsx`;
    yield call(exportXlsxFromBlob, { filename, data: payload });
  } catch (error: any) {
    toast.error('Unable to export Projects data');
    console.error('watchExportAllProjectsTableData: ', error);
  }
}

export function* watchExportBidVolumeAndWinRateChartData(action: any) {
  try {
    const { payload } = action;
    const filename = `win_rate_${moment(new Date()).format('MM-DD-YY')}.xlsx`;
    yield call(exportXlsxFromBlob, { filename, data: payload });
  } catch (error: any) {
    toast.error('Unable to export Bid Volume and Win Rate data');
    //rollbar.error('watchExportBidVolumeAndWinRateChartData: ', error);
  }
}

export function* watchExportPricingChartData(action: any) {
  try {
    const { payload } = action;
    const filename = `pricing_${moment(new Date()).format('MM-DD-YY')}.xlsx`;
    yield call(exportXlsxFromBlob, { filename, data: payload });
  } catch (error: any) {
    toast.error('Unable to export Pricing Chart');
    //rollbar.error('watchExportPricingChartData: ', error);
  }
}

export function* watchExportFactorAnalysisTableData(action: any) {
  try {
    const { payload } = action;
    const filename = `factor_analysis_${moment(new Date()).format(
      'MM-DD-YY'
    )}.xlsx`;
    yield call(exportXlsxFromBlob, { filename, data: payload });
  } catch (error: any) {
    toast.error('Unable to export Factor Analysis table');
    //rollbar.error('watchExportFactorAnalysisTableData: ', error);
  }
}

export function* watchExportRevenueForecastChartData(action: any) {
  try {
    const { payload } = action;
    const filename = `forecast_${moment(new Date()).format('MM-DD-YY')}.xlsx`;
    yield call(exportXlsxFromBlob, { filename, data: payload });
  } catch (error: any) {
    toast.error('Unable to export Revenue Forecast Chart');
    //rollbar.error('watchExportRevenueForecastChartData: ', error);
  }
}
